import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { ROUTES } from '@constants/routes';
import { scrollToTop } from '@utils/usefulFuncs';
import { Header } from '@app/navigation/header';
import { Body, Container, H5, Page } from '@ui';
import BackArrowButton from '@ui/buttons/BackArrowButton';
import { FlatButton } from '@ui/buttons';
import { SkeletonButton } from '@ui/buttons/SkeletonButton';
import { GenerateAgentScriptPanel } from './GenerateAgentScriptPanel';
import { ImproveAgentScriptPanel } from './ImproveAgentScriptPanel';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const TabRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

const MODES = {
  generate: 'generate',
  improve: 'improve',
};

/**
 * Route container for agent-script authoring. Hosts two modes — generate a new
 * script, or improve an existing one — behind a simple tab toggle.
 */
export const AgentScriptGenerator = () => {
  const navigate = useNavigate();
  const [mode, setMode] = React.useState(MODES.generate);

  React.useEffect(() => {
    scrollToTop();
  }, []);

  const GenerateTab = mode === MODES.generate ? FlatButton : SkeletonButton;
  const ImproveTab = mode === MODES.improve ? FlatButton : SkeletonButton;

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <Page>
          <BackArrowButton onClick={() => navigate(ROUTES.home)} />
          <Container top={36}>
            <H5 bold>Agent Script Generator</H5>
          </Container>

          <Container top={24}>
            <TabRow>
              <GenerateTab onClick={() => setMode(MODES.generate)}>Generate New</GenerateTab>
              <ImproveTab onClick={() => setMode(MODES.improve)}>Improve Existing</ImproveTab>
            </TabRow>
          </Container>

          <Container top={32}>
            {mode === MODES.generate ? <GenerateAgentScriptPanel /> : <ImproveAgentScriptPanel />}
          </Container>
        </Page>
      </Body>
    </PageWrapper>
  );
};
